export const findCyclePricing = (interval, cyclePricing) => {
  return cyclePricing == null ? void 0 : cyclePricing.find(pricing => {
    var _pricing$cycle;
    const {
      unit,
      count
    } = (pricing == null || (_pricing$cycle = pricing.cycle) == null ? void 0 : _pricing$cycle.interval) ?? {};
    return interval.unit === unit && interval.count === count;
  });
};
//# sourceMappingURL=findCyclePricing.js.map